/** Shared sun/battery side-card class names for green-energy carousels. */
export function ecoCardClassName(active) {
  return `green-energy-eco-card${active ? ' green-energy-eco-card--active' : ''}`;
}

export function ecoCardValueClassName({ active, charging } = {}) {
  if (active) return 'green-energy-eco-card__value green-energy-eco-card__value--active';
  if (charging) return 'green-energy-eco-card__value green-energy-eco-card__value--charging';
  return 'green-energy-eco-card__value green-energy-eco-card__value--muted';
}

export function isGreenEnergyCarouselMobile() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(max-width: 768px)').matches;
}

export function scrollGreenEnergyCarouselToCenter(root) {
  if (!root) return;
  if (!isGreenEnergyCarouselMobile()) {
    root.scrollLeft = 0;
    return;
  }
  const main = root.querySelector('.green-energy-main-card');
  if (!main) return;
  const target = main.offsetLeft - (root.clientWidth - main.offsetWidth) / 2;
  root.scrollLeft = Math.max(0, target);
}
